module.exports = __webpack_public_path__ + "static/media/check.8b4d6e74.svg";